import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/blog/error.tsx");
